<app-slider></app-slider>
<div class="loading">
    <div class="wrapper padding-top-30">
        <div class="container">
            <p>Oops, The page you are looking for can't be found!</p>
            <div class="missing-page">
                <span class="side">4</span>
                <span class="taiji-icon"></span>
                <span class="side">4</span>
            </div>
            <p>Loading...</p>
        </div>
    </div>
</div>
<div class="socail-media padding-top-30">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                <instagram-post></instagram-post>
            </div>
            <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                <tumblr-posts></tumblr-posts>
            </div>
        </div>
    </div>
</div>
